var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { "max-width": "500" } },
    [
      _c(
        "w-card-title",
        [
          _vm._v(" " + _vm._s(_vm.$ct("repeated-tasks")) + " "),
          _c("w-spacer"),
          _c(
            "w-link",
            {
              attrs: { white: "" },
              on: {
                click: function ($event) {
                  return _vm.close()
                },
              },
            },
            [_c("w-fa", { attrs: { icon: "times" } })],
            1
          ),
        ],
        1
      ),
      _vm.tasks.length == 0
        ? _c(
            "w-card-content",
            [
              _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    {
                      staticClass: "empty-list",
                      attrs: { xs: "12", center: "" },
                    },
                    [_vm._v(" " + _vm._s(_vm.$ct("no-repeated-tasks")) + " ")]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "w-scroll-view",
        { attrs: { "w-tag": "w-list" } },
        _vm._l(_vm.tasks, function (task) {
          return _c(
            "w-list-item",
            { key: task.ID },
            [
              _c("w-list-item-text", [_vm._v(" " + _vm._s(task.Text) + " ")]),
              _c(
                "w-list-item-action",
                [
                  _c(
                    "w-button",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: _vm.$ct("common.edit"),
                          expression: "$ct('common.edit')",
                        },
                      ],
                      on: {
                        click: function ($event) {
                          _vm.toManageTask = task
                        },
                      },
                    },
                    [_c("w-fa", { attrs: { icon: "pen" } })],
                    1
                  ),
                ],
                1
              ),
              _c(
                "w-list-item-action",
                [
                  _c(
                    "w-button",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: _vm.$ct("stop-task"),
                          expression: "$ct('stop-task')",
                        },
                      ],
                      staticClass: "danger",
                      on: {
                        click: function ($event) {
                          return _vm.stopTask(task)
                        },
                      },
                    },
                    [_c("w-fa", { attrs: { icon: "ban" } })],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        }),
        1
      ),
      _c(
        "w-card-actions",
        [
          _c("w-spacer"),
          _c(
            "w-button",
            {
              attrs: { icon: "plus" },
              on: {
                click: function ($event) {
                  return _vm.createNew()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$ct("create-repeated-task")) + " ")]
          ),
        ],
        1
      ),
      _vm.toManageTask
        ? _c(
            "w-modal",
            { attrs: { value: "" } },
            [
              _c("app-repeated-task-edit-modal", {
                attrs: { value: _vm.toManageTask },
                on: {
                  input: function ($event) {
                    return _vm.onTaskUpdate($event)
                  },
                  close: function ($event) {
                    _vm.toManageTask = null
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }